import React from "react";
import { IconButton, withStyles } from "@material-ui/core";
import { Refresh } from "@material-ui/icons";
import appConstants from "../../../../../appConstants";
import Events from "../../../../../utilities/EventEmitter";
import Tooltip from "../../../../common/StyledToolTip";
const TIMER_UPDATE_INTERVAL_IN_SECOND = 5;
const styles = (theme) => ({
  lastUpdateStatusBar: {
    fontSize: theme.dispatchCardTextFontSize,
    color: theme.iconColor,
    fontWeight: 600,
  },
  refreshIcon: {
    fontSize: 20,
    color: theme.iconColor,
    margin: 4,
    opacity: .6
  },
  lastRefreshButton: {
    padding: "0px",
    marginLeft: "auto",
    alignSelf: "center",
  },
});

class AutoRefreshKPI extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lastRefreshTimeDifference: 0,
    };
    this.intervaltimer = null;
    this.timerCounter = null;
  }
  componentDidMount() {
    this.startAutoRefreshTimer();
    Events.on("SetDispatchKPIRefreshTime", this.resetTimer);
  }

  componentWillUnmount() {
    clearInterval(this.intervaltimer);
    clearInterval(this.timerCounter);
    Events.off("SetDispatchKPIRefreshTime", this.resetTimer);
  }

  startAutoRefreshTimer = () => {
    //timer to fetch kpi data
    clearInterval(this.intervaltimer);
    this.intervaltimer = setInterval(() => {
      this.props.onRefreshClick();
    }, appConstants.ONE_MINUTE_TIME_OUT);

    //timer to show last fetched counter
    clearInterval(this.timerCounter);
    this.timerCounter = setInterval(() => {
      this.setState((prevState) => ({
        lastRefreshTimeDifference:
          prevState.lastRefreshTimeDifference + TIMER_UPDATE_INTERVAL_IN_SECOND,
      }));
    }, appConstants.ONE_SECOND_TIME_OUT * TIMER_UPDATE_INTERVAL_IN_SECOND);
  };

  resetTimer = () => {
    this.setState({ lastRefreshTimeDifference: 0 });
    this.startAutoRefreshTimer();
  };

  render() {
    const { classes } = this.props;
    return (
      <Tooltip
        placement="top"
        title={
          <spn className={classes.lastUpdateStatusBar}>
            Last refreshed at {this.state.lastRefreshTimeDifference} seconds ago
          </spn>
        }
        disableFocusListener
      >
        <IconButton
          className={classes.lastRefreshButton}
          onClick={() => this.props.onRefreshClick(true)}
        >
          <Refresh className={classes.refreshIcon} />
        </IconButton>
      </Tooltip>
    );
  }
}
export default withStyles(styles)(AutoRefreshKPI);
